import axios from 'axios';
// Client that should be used when trying to use tokens for secure API requests
export const axiosAuthClient = axios.create({ withCredentials: true });
